// ─────────────────────────────────────────────
//  useBroadcasts — live TV-mode broadcast announcements for a facility + day.
//  Listener only; writes (AIC-gated) go through the firestore broadcast helpers
//  from the component, which has the auth context. Newest-first.
// ─────────────────────────────────────────────
import { useEffect, useState } from "react";
import { listenToBroadcasts } from "../firebase/firestore";

export function useBroadcasts(facilityId, dateKey) {
  const [broadcasts, setBroadcasts] = useState([]);
  useEffect(() => {
    if (!facilityId || !dateKey) { setBroadcasts([]); return undefined; }
    return listenToBroadcasts(facilityId, dateKey, setBroadcasts);
  }, [facilityId, dateKey]);
  return broadcasts;
}
